import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import getBaseQueryWithReauth from '../../../utils/api/query-auth'
import getAuth from '../../../utils/api/getToken'
import { Branch } from '../../../types/branch'

const baseQuery = fetchBaseQuery({
	baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Company`,
	prepareHeaders: headers => {
		const token = getAuth()
		if (token) {
			headers.set('authorization', `Bearer ${token.auth}`)
		}
		return headers
	},
})

// Accepts company as a string (name or id)
export const branchesApi = createApi({
	reducerPath: 'branches',
	baseQuery: getBaseQueryWithReauth(baseQuery),
	keepUnusedDataFor: 60 * 60, // Cache por 1 hora
	tagTypes: ['Branches'],
	endpoints: builder => ({
		getBranches: builder.query<Branch[], string | void>({
			query: () => {
				return `/getCompanyBranches`
			},
			providesTags: (res, err, branch) => [{ type: 'Branches' }],
		}),
	}),
})

// Export hooks for usage in functional components
export const { useGetBranchesQuery } = branchesApi
